import React from "react";

export default function MuteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <g
        stroke="#FCFCFC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        clipPath="url(#clip0_418_15642)"
      >
        <path fill="#FCFCFC" d="M11.5 5.07l-5 4h-4v6h4l5 4v-14z"></path>
        <path d="M23.5 9.07l-6 6M17.5 9.07l6 6"></path>
      </g>
      <defs>
        <clipPath id="clip0_418_15642">
          <path
            fill="#fff"
            d="M0 0H24V24H0z"
            transform="translate(.5 .07)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}